export enum AutoBuildsState {
  InProgress = 1,
  Completed,
  Cancelled,
}
